module.exports = __webpack_public_path__ + "static/media/S (112).93d12284.jpg";